import { MarketCountryCode } from '@backmarket/http-api'
import type { Features } from '@backmarket/nuxt-module-marketplace/features'

export const features: Record<MarketCountryCode, Features> = {
  [MarketCountryCode.FR]: {
    mobilePlan: { enabled: true },
    goodDeals: { enabled: true },
    holidays: { enabled: true },
    blackFriday: { enabled: true },
    cgvModalLegals: true,
    coolingOffDays: 30,
    mobileApp: { available: true },
    showCarrier: false,
    trustmark: 'trusted-shops',
    trustedShopsId: 'X194F6470570B4368A91A3C7230E9014C',
    trustpilotConfig: {
      businessUnitId: '55671b1d0000ff00057fba42',
      websiteHref: 'https://fr.trustpilot.com/review/backmarket.fr',
    },
    vatIncluded: false,
    warranty: { displayInYear: false, duration: 12 },
    repair: { enabled: true },
  },
  [MarketCountryCode.AT]: {
    mobilePlan: { enabled: false },
    goodDeals: { enabled: true },
    holidays: { enabled: false },
    blackFriday: { enabled: false },
    cgvModalLegals: false,
    coolingOffDays: 30,
    mobileApp: { available: true },
    trustmark: 'trusted-shops',
    trustedShopsId: 'XE714EB9CDE3DA7C8DD4DCFF5B0CE6B9E',
    trustpilotConfig: {
      businessUnitId: '5eb28e49efd43f0001d98949',
      websiteHref: 'https://at.trustpilot.com/review/backmarket.at',
    },
    showCarrier: false,
    vatIncluded: true,
    warranty: { displayInYear: false, duration: 12 },
    repair: { enabled: false },
  },
  [MarketCountryCode.BE]: {
    mobilePlan: { enabled: false },
    goodDeals: { enabled: true },
    holidays: { enabled: false },
    blackFriday: { enabled: false },
    cgvModalLegals: true,
    coolingOffDays: 30,
    mobileApp: { available: true },
    showCarrier: false,
    trustmark: 'trusted-shops',
    trustedShopsId: 'XB9BE628A37B8B2E1477584BD94039251',
    trustpilotConfig: {
      businessUnitId: '5c7e45b3b62d9a000147ad24',
      websiteHref: 'https://be.trustpilot.com/review/backmarket.be',
    },
    vatIncluded: false,
    warranty: { displayInYear: false, duration: 12 },
    repair: { enabled: false },
  },
  [MarketCountryCode.DE]: {
    cgvModalLegals: false,
    coolingOffDays: 30,
    mobilePlan: { enabled: false },
    goodDeals: { enabled: true },
    holidays: { enabled: true },
    blackFriday: { enabled: true },
    mobileApp: { available: true },
    showCarrier: false,
    trustmark: 'trusted-shops',
    trustedShopsId: 'X0D2D87BCBFAE89812C9338C968A4BD77',
    trustpilotConfig: {
      businessUnitId: '5aa797f22e380e0001660eae',
      websiteHref: 'https://de.trustpilot.com/review/www.backmarket.de',
    },
    vatIncluded: true,
    warranty: { displayInYear: false, duration: 12 },
    repair: { enabled: true },
  },
  [MarketCountryCode.ES]: {
    cgvModalLegals: false,
    coolingOffDays: 30,
    mobilePlan: { enabled: false },
    goodDeals: { enabled: true },
    holidays: { enabled: true },
    blackFriday: { enabled: true },
    mobileApp: { available: true },
    showCarrier: false,
    trustmark: 'confianza-online',
    trustedShopsId: 'X416F4F5FD9E8CB7EC326CBA57589BE5B',
    trustpilotConfig: {
      businessUnitId: '5aa797eb350d930001066e91',
      websiteHref: 'https://es.trustpilot.com/review/www.backmarket.es',
    },
    vatIncluded: true,
    warranty: { displayInYear: true, duration: 2 },
    repair: { enabled: true },
  },
  [MarketCountryCode.FI]: {
    cgvModalLegals: true,
    coolingOffDays: 30,
    mobilePlan: { enabled: false },
    goodDeals: { enabled: false },
    holidays: { enabled: false },
    blackFriday: { enabled: false },
    mobileApp: { available: true },
    showCarrier: false,
    trustmark: 'trustpilot',
    trustpilotConfig: {
      businessUnitId: '5eb28e4f90998f0001ecc108',
      websiteHref: 'https://fi.trustpilot.com/review/www.backmarket.fi',
    },
    vatIncluded: false,
    warranty: { displayInYear: false, duration: 12 },
    repair: { enabled: false },
  },
  [MarketCountryCode.GB]: {
    cgvModalLegals: false,
    coolingOffDays: 30,
    mobilePlan: { enabled: false },
    goodDeals: { enabled: true },
    holidays: { enabled: true },
    blackFriday: { enabled: true },
    mobileApp: { available: true },
    showCarrier: false,
    trustmark: 'trustpilot',
    trustpilotConfig: {
      businessUnitId: '5e2b02758b37ba0001e1d426',
      websiteHref: 'https://uk.trustpilot.com/review/www.backmarket.co.uk',
    },
    vatIncluded: false,
    warranty: { duration: 12, displayInYear: false },
    repair: { enabled: false },
  },
  [MarketCountryCode.GR]: {
    cgvModalLegals: true,
    coolingOffDays: 30,
    mobilePlan: { enabled: false },
    goodDeals: { enabled: true },
    holidays: { enabled: false },
    blackFriday: { enabled: false },
    mobileApp: { available: true },
    showCarrier: false,
    trustmark: 'trustpilot',
    trustpilotConfig: {
      businessUnitId: '60634b8d27f4190001f3896e',
      websiteHref: 'https://gr.trustpilot.com/review/www.backmarket.gr',
    },
    vatIncluded: false,
    warranty: { displayInYear: false, duration: 12 },
    repair: { enabled: false },
  },
  [MarketCountryCode.IE]: {
    cgvModalLegals: true,
    coolingOffDays: 30,
    mobilePlan: { enabled: false },
    goodDeals: { enabled: true },
    holidays: { enabled: false },
    blackFriday: { enabled: false },
    mobileApp: { available: true },
    showCarrier: false,
    trustmark: 'trustpilot',
    trustpilotConfig: {
      businessUnitId: '60634b8927f4190001f3896b',
      websiteHref: 'https://ie.trustpilot.com/review/www.backmarket.ie',
    },
    vatIncluded: false,
    warranty: { displayInYear: false, duration: 12 },
    repair: { enabled: false },
  },
  [MarketCountryCode.IT]: {
    cgvModalLegals: false,
    coolingOffDays: 30,
    mobilePlan: { enabled: false },
    goodDeals: { enabled: true },
    holidays: { enabled: false },
    blackFriday: { enabled: false },
    mobileApp: { available: true },
    showCarrier: false,
    trustmark: 'trustpilot',
    trustpilotConfig: {
      businessUnitId: '5c6301badc82bd00015430aa',
      websiteHref: 'https://it.trustpilot.com/review/www.backmarket.it',
    },
    vatIncluded: false,
    warranty: { duration: 12, displayInYear: false },
    repair: { enabled: false },
  },
  [MarketCountryCode.NL]: {
    cgvModalLegals: false,
    coolingOffDays: 30,
    mobilePlan: { enabled: false },
    goodDeals: { enabled: true },
    holidays: { enabled: false },
    blackFriday: { enabled: false },
    mobileApp: { available: true },
    showCarrier: false,
    trustmark: 'trusted-shops',
    trustpilotConfig: {
      businessUnitId: '5eb28e4c90998f0001ecc106',
      websiteHref: 'https://nl.trustpilot.com/review/www.backmarket.nl',
    },
    vatIncluded: false,
    warranty: { duration: 12, displayInYear: false },
    repair: { enabled: false },
  },
  [MarketCountryCode.PT]: {
    cgvModalLegals: true,
    coolingOffDays: 30,
    mobilePlan: { enabled: false },
    goodDeals: { enabled: true },
    holidays: { enabled: false },
    blackFriday: { enabled: false },
    mobileApp: { available: true },
    showCarrier: false,
    trustmark: 'trustpilot',
    trustpilotConfig: {
      businessUnitId: '60377c9970c83a000172de3d',
      websiteHref: 'https://pt.trustpilot.com/review/www.backmarket.pt',
    },
    vatIncluded: false,
    warranty: { displayInYear: true, duration: 2 },
    repair: { enabled: false },
  },
  [MarketCountryCode.SE]: {
    cgvModalLegals: true,
    coolingOffDays: 30,
    mobilePlan: { enabled: false },
    goodDeals: { enabled: false },
    holidays: { enabled: false },
    blackFriday: { enabled: false },
    mobileApp: { available: false },
    showCarrier: false,
    trustmark: 'none',
    trustpilotConfig: {
      businessUnitId: '60634bad27f4190001f38973',
      websiteHref: 'https://se.trustpilot.com/review/www.backmarket.se',
    },
    vatIncluded: true,
    warranty: { displayInYear: false, duration: 12 },
    repair: { enabled: false },
  },
  [MarketCountryCode.SK]: {
    cgvModalLegals: true,
    coolingOffDays: 30,
    mobilePlan: { enabled: false },
    goodDeals: { enabled: true },
    holidays: { enabled: false },
    blackFriday: { enabled: false },
    mobileApp: { available: true },
    showCarrier: false,
    trustmark: 'none',
    trustpilotConfig: {
      businessUnitId: '60634bb1e143b400018548c0',
      websiteHref: 'https://sk.trustpilot.com/review/www.backmarket.sk',
    },
    vatIncluded: true,
    warranty: { displayInYear: false, duration: 12 },
    repair: { enabled: false },
  },
  [MarketCountryCode.US]: {
    cgvModalLegals: false,
    coolingOffDays: 30,
    mobilePlan: { enabled: true },
    goodDeals: { enabled: true },
    holidays: { enabled: true },
    blackFriday: { enabled: true },
    mobileApp: { available: true },
    showCarrier: true,
    trustmark: 'none',
    trustpilotConfig: {
      businessUnitId: '5b59c4940889b80001628f28',
      websiteHref: 'https://trustpilot.com/review/www.backmarket.com',
    },
    vatIncluded: false,
    warranty: { duration: 1, displayInYear: true },
    repair: { enabled: false },
  },
  [MarketCountryCode.JP]: {
    cgvModalLegals: false,
    coolingOffDays: 30,
    mobilePlan: { enabled: false },
    goodDeals: { enabled: true },
    holidays: { enabled: false },
    blackFriday: { enabled: false },
    mobileApp: { available: false },
    showCarrier: false,
    trustmark: 'none',
    trustpilotConfig: { businessUnitId: '', websiteHref: '' },
    vatIncluded: true,
    warranty: { duration: 12, displayInYear: false },
    repair: { enabled: false },
  },
  [MarketCountryCode.AU]: {
    cgvModalLegals: false,
    coolingOffDays: 30,
    mobilePlan: { enabled: false },
    goodDeals: { enabled: true },
    holidays: { enabled: false },
    blackFriday: { enabled: false },
    mobileApp: { available: false },
    showCarrier: false,
    trustmark: 'none',
    trustpilotConfig: {
      businessUnitId: '64f5cf267b782062676c8a03',
      websiteHref: 'https://au.trustpilot.com/review/backmarket.com.au',
    },
    vatIncluded: true,
    warranty: { duration: 1, displayInYear: true },
    repair: { enabled: false },
  },
}
